<template>
  <div class="container">
    <div style="display: flex; height: 100%">
      <div style="background-color: #dfdfe2; overflow-y: auto"
           v-loading="organsInLevels.length === 0"
           :style="{height: tableHeight + 'px'}">
        <el-tree :data="organsInLevels"
                 :expand-on-click-node="false"
                 default-expand-all
                 @current-change="currentChange"
                 style="width: 220px; background-color: transparent; padding: 10px 10px 0 0;">
          <template #default="{ data }">
            <div :class="{'selected' : selectedOrganData === data}">{{ data.label }}</div>
          </template>
        </el-tree>
      </div>
      <div style="width: calc(100% - 220px)">
        <div style="margin: -42px 0 10px 10px">
          <el-input prefix-icon="el-icon-search" clearable v-model="searchText"
                    style="width: 260px; margin-right: 10px"></el-input>
          <el-button style="margin-left: 10px" @click="loadData">查询</el-button>
        </div>
        <el-table :data="userList" style="height: 100%" class="table-border" v-loading="userList === null"
                  header-cell-class-name="table-head" :height="tableHeight">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column label="手机号" prop="cellphone"></el-table-column>
          <el-table-column label="姓名" prop="name"></el-table-column>
          <el-table-column label="状态" width="60">
            <template #default="{row}">
              {{row.status | status}}
            </template>
          </el-table-column>
          <el-table-column label="微信" width="60" align="center">
            <template #default="{row}">
              <el-button type="text" v-if="row.openid" @click="unbindWechat(row)" size="mini">解绑</el-button>
              <label v-else>未绑定</label>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="remarks"></el-table-column>

          <el-table-column :width="deletable ? 70 : 80" align="center" fixed="right">
            <template #header>
              <el-button v-if="addable && !deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
            </template>
            <template #default="{row}">
              <el-button v-if="isRoot" type="text" @click="edit(row)" size="mini">编辑</el-button>
              <el-button v-else type="text" @click="edit(row)" size="mini">
                {{(readOnly || !row.editable) ? '查看' : '编辑'}}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column :width="deletable ? 80: 1" align="center" fixed="right">
            <template #header>
              <el-button v-if="addable && deletable" icon="el-icon-plus" type="primary" @click="add"></el-button>
            </template>
            <template #default="{row}">
              <el-button v-if="isRoot" type="text" @click="deleteUser(row)" size="mini" class="danger">
                删除
              </el-button>
              <el-button v-else :disabled="!row.editable" type="text" size="mini" @click="deleteUser(row)"
                         class="danger">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <edit-user-dialog :visible.sync="dialog.show"
                      :user="dialog.user"
                      :read-only="!isRoot && (readOnly || !dialog.user.editable)"
                      :organ="selectedOrganData"
                      @add="onAddUser"
                      @update="onUpdateUser">
    </edit-user-dialog>
  </div>
</template>

<script>
  import { allOrgansInLevels, deleteUser, unbindOpenid, userListByOrgan } from '@/utils/request'
  import { User } from '@/store/objdef/objectDef'
  import EditUserDialog from '@/views/user/EditUser'
  import authority from '@/utils/authority'
  import { shareDataMixin } from '@/views/mixins/ShareData'
  import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'

  export default {
    name: 'UserList',
    mixins: [shareDataMixin, resizeCaptureMixin],
    components: { EditUserDialog },
    data () {
      return {
        organsInLevels: [],
        selectedOrganData: {},
        userList: null,
        searchText: null,
        dialog: {
          show: false,
          user: new User()
        }
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        allOrgansInLevels().then((response) => {
          this.organsInLevels.push(response.data)
          const level = this.$store.state.user.level
          switch (level) {
            case 'GROUP':
              this.selectedOrganData = response.data
              break

            case 'WORKSHOP':
              this.selectedOrganData = this.findCurWorkshop(response.data.children)
              break

            default:
              for (const shop of this.findCurWorkshop(response.data.children).children) {
                if (shop.id === this.$store.state.user.shopId) {
                  this.selectedOrganData = shop
                  break
                }
              }
          }
          this.currentChange(this.selectedOrganData)
        })
      },
      currentChange (data) {
        this.selectedOrganData = data
        this.userList = null
        userListByOrgan(this.selectedOrganData.type, this.selectedOrganData.id).then(response => {
          this.userList = response.data
        })
      },
      findCurWorkshop (workshops) {
        for (const workshop of workshops) {
          if (workshop.code === process.env.VUE_APP_CODE) {
            return workshop
          }
        }
      },
      add () {
        this.dialog.user = new User()
        this.dialog.show = true
      },
      onAddUser (user) {
        this.userList.push(user)
        this.$message.success('添加成功!')
      },
      deleteUser (user) {
        this.$confirm(`确认删用户【${user.name}】, 是否继续?`, '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteUser(user).then(() => {
            for (const i in this.userList) {
              if (this.userList[i].id === user.id) {
                this.userList.splice(i, 1)
                break
              }
            }
            this.$message.success('删除成功!')
          })
        }).catch(() => {
        })
      },
      edit (user) {
        this.dialog.user = this.$_.cloneDeep(user)
        this.dialog.show = true
      },
      onUpdateUser (user) {
        for (const item of this.userList) {
          if (item.id === user.id) {
            Object.assign(item, user)
          }
        }
      },
      unbindWechat (user) {
        unbindOpenid(user).then(() => {
          user.openid = undefined
        })
      }
    },
    computed: {
      readOnly () {
        return !this.$hasPermission(authority.EDIT_USER)
      },
      addable () {
        return this.$hasPermission(authority.ADD_USER)
      },
      deletable () {
        return this.$hasPermission(authority.DELETE_USER)
      },
      tableHeight () {
        return this.clientHeight - 170
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ {
    .el-tree-node__content {
      height: 28px;
    }

    .el-tree-node__label {
      font-size: 15px;
    }

    .selected,
    .el-tree-node__content:hover,
    .el-tree-node:focus > .el-tree-node__content {
      color: white;
      background-color: #1890ff;
      border-radius: 4px;
    }

    th {
      height: 50px;
    }
  }
</style>
